export default class ForgotPasswordController {
  constructor($rootScope, $state, User) {
    this.$state = $state;
    this.User = User;
    this.email = '';
    this.waiting = false;
    this.error = false;
    this.sent = false;
    this.server = null;
    this.serverEmail = false;

    $rootScope.$on('$receivedServerStatus', (evt, data) => {
      this.status = data;
    });

  }

  goToLogin = () => {
    this.$state.go('auth.login');
  };

  clearError = () => {
    this.error = false;
  };

  getServerForEmail = (email) => {
    let server = null;
    if (this.status && this.status.imapDomains) {
      for (let i = 0; i < this.status.imapDomains.length; i++) {
        if (email.trim().endsWith(this.status.imapDomains[i].domain)) {
          return this.status.imapDomains[i];
        }
      }
    }
    return server;
  };

  resetPassword = () => {
    this.waiting = true;
    this.error = !this.validEmail(this.email);

    if (!this.error) {
      // If account is from a server, show message only and redirect to login
      this.server = this.getServerForEmail(this.email);
      if (this.server) {
        this.waiting = false;
        this.serverEmail = true;
      } else {
        // Reset password for local accounts
        this.User.resetPassword({
          email: this.email
        }).$promise.then((res) => {
          this.sent = true;
          this.waiting = false;
        }).catch((error) => {
          console.log(error);
          this.sent = true;
          this.waiting = false;
        })
      }
    }
  };

  // Returns true if email is valid, false if not
  validEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };
}

ForgotPasswordController.$inject = ['$rootScope', '$state', 'User'];
